import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgPrice = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="url(#price_svg__a)"
        d="M12 2.855a9.147 9.147 0 1 0 0 18.293 9.147 9.147 0 0 0 0-18.293"
      />
      <path
        fill="#fff"
        d="M11.577 17.978v-.914c-1.603-.116-2.865-.907-3.213-2.117a1.4 1.4 0 0 1-.058-.37c0-.414.283-.697.725-.697.349 0 .602.182.755.566.24.682.754 1.19 1.792 1.298v-3.162l-.297-.074c-1.843-.427-2.837-1.255-2.837-2.727 0-1.631 1.306-2.698 3.134-2.836v-.92c0-.255.174-.414.413-.414.232 0 .406.16.406.413v.922c1.545.123 2.72.943 3.06 2.14.037.123.052.239.052.37 0 .392-.29.66-.711.66-.378 0-.617-.21-.77-.559-.304-.754-.826-1.19-1.631-1.292v3.025l.348.087c1.908.443 2.952 1.226 2.952 2.771 0 1.784-1.45 2.785-3.3 2.916v.914c0 .255-.174.413-.406.413-.24 0-.414-.158-.414-.413m0-6.876V8.265c-1.044.124-1.596.726-1.596 1.393 0 .66.436 1.147 1.596 1.444m.82 1.675v2.974c1.24-.094 1.763-.682 1.763-1.458 0-.754-.414-1.196-1.763-1.516"
      />
      <defs>
        <linearGradient
          id="price_svg__a"
          x1={3.844}
          x2={20.093}
          y1={3.846}
          y2={20.094}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ef9c43" stopOpacity={0.75} />
          <stop offset={1} stopColor="#ef9c43" />
        </linearGradient>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgPrice);
export default Memo;
